export const PAGE_LOADER_WEB_CONTAINER_ID = 'page-loader-web-container';
export const PAGE_LOADER_WEB_SENTENCE_ID = 'page-loader-web-sentence';
